import {
	ENDPOINT_CONFIRM_VEHICLE,
	ENDPOINT_CREATE_VEHICLE,
	ENDPOINT_DELETE_VEHICLE,
	ENDPOINT_VEHICLES,
} from '../../endpoints';

import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { IEsOnehubVWConfig } from '../models/es-one-hub-config';

export const getVehicles = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = ENDPOINT_VEHICLES;
	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const confirmVehicle = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	carFrame: string,
): Promise<Response> => {
	const endpoint = ENDPOINT_CONFIRM_VEHICLE;

	const confirmData = {
		frame: carFrame,
	};

	const response = await authServiceInstance.patch(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify(confirmData),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const deleteVehicle = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	carFrame: string,
): Promise<Response> => {
	const endpoint = ENDPOINT_DELETE_VEHICLE;

	const deleteData = {
		frame: carFrame,
	};

	const response = await authServiceInstance.delete(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify(deleteData),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const createVehicle = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	carFrame: string,
	carLicense: string,
	fichaTecnicaFile: File,
	permisoCirculacionFile: File,
): Promise<Response> => {
	const endpoint = ENDPOINT_CREATE_VEHICLE;
	const formData = new FormData();
	formData.append('frame', carFrame);
	formData.append('license', carLicense);
	formData.append('drivingLicense', permisoCirculacionFile);
	formData.append('technicalSpecs', fichaTecnicaFile);
	formData.append('close', 'fichaTecnicaFile');

	const response = await authServiceInstance.post(esOnehubVWConfig.resourceHostId, endpoint, formData);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};
